import { render, staticRenderFns } from "./tow.vue?vue&type=template&id=515e5349"
import script from "./tow.vue?vue&type=script&lang=js"
export * from "./tow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports